import getAdminToolsFlyoutItems from 'lhs/services/admin-tools-flyout-config';
import React from 'react';
import { AngularContext } from 'react-app';
import t from 'react-translate';
import FlyoutContainer from './flyout-container';
import FlyoutMenuItem from './flyout-menu-item';
import { EmptyContent } from './loading-placeholders';

export const AdminToolsPanel = () => {
  const { injectServices } = React.useContext(AngularContext);
  const [CurrentPermissionsManager] = injectServices(['CurrentPermissionsManager']);
  const adminToolsItems = getAdminToolsFlyoutItems(t, CurrentPermissionsManager);

  const noItems = !adminToolsItems || adminToolsItems?.length === 0;

  return (
    <FlyoutContainer title={t.LHS.ORG_ADMIN_TOOLS()}>
      { noItems
        ? <EmptyContent text={t.LHS.NO_ITEMS()} />
        : adminToolsItems.map(item => (
          <FlyoutMenuItem {...item} />
        ))}
    </FlyoutContainer>
  );
};

export default AdminToolsPanel;
